export const genRunningText = (progressRate?: number): string => {
  if (progressRate) {
    return `Running... ${(progressRate * 100).toFixed(0)}%`;
  }

  return 'Running';
};

export const genCompleteText = (errors?: string): string => {
  if (errors) {
    return `Completed with errors`;
  }

  return 'Completed';
};
